import Vue from "vue";
import "./plugins/axios";
import "./plugins/fontawesome";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { startSessionReplay } from "@/plugins/sessionReplay";
import Paginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker";
import ProgressBar from "@/components/progressBar.vue";
import "./assets/css/common.css";
import "./assets/css/reset.css";
import "./assets/css/bootstrap_modal.min.css";
import "./assets/css/style.css";
import "./assets/js/bootstrap.js";

startSessionReplay();

Vue.config.productionTip = false;

// 이벤트 버스 import없이 전역으로 사용하기 위함
Vue.prototype.$EventBus = new Vue();

// 프로그래스 컴포넌트 전역 설정
Vue.component("ProgressBar", ProgressBar);

// 페이징 컴포넌트 전역 설정
Vue.component("Paginate", Paginate);
// DatePicker 컴포넌트 전역 설정
Vue.component("Datepicker", Datepicker);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
